import { render, staticRenderFns } from "./MantenedorTransbankPantalla.vue?vue&type=template&id=3bb56328&"
import script from "./MantenedorTransbankPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTransbankPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3bb56328', component.options)
    } else {
      api.reload('3bb56328', component.options)
    }
    module.hot.accept("./MantenedorTransbankPantalla.vue?vue&type=template&id=3bb56328&", function () {
      api.rerender('3bb56328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTransbank/MantenedorTransbankPantalla.vue"
export default component.exports